import React from 'react';
import BlogDetail from '../components/BlogDetail';

const BlogDetailPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 pt-20">
      <BlogDetail />
    </div>
  );
};

export default BlogDetailPage;
